// site/src/components/download-closely/brandedApp.js

/**
 * Closely 默认品牌资产。
 * 三个值必须与改动前 index.vue / intallClosely.vue 里的硬编码值逐字一致 ——
 * 未配置品牌字段的客户要看到完全相同的结果。
 */
const CLOSELY_DEFAULT = {
    appName: 'Closely App',
    appIcon: 'https://cdn.chime.me/image/fs/sitebuild/20221227/22/original_87bc384e-2723-400f-bfb7-2e5fddbfbc54.png',
    downloadBadge: 'https://cdn.chime.me/image/fs/sitebuild/2024619/10/original_e777b5d6-4706-4fb0-95da-9934a5ee3fc6.jpg'
};

/**
 * 从站点 closely-app 配置解析品牌资产。
 *
 * @param {Object} closelyConfig page['closely-app']，其 customer 段是该 team 的
 *        closely_config.data 全量下发（见 PageService.addCloselyConfig）
 * @returns {{appName: string, appIcon: string, downloadBadge: string}} 恒非空
 */
export function resolveBrandedApp(closelyConfig) {
    const branch = closelyConfig && closelyConfig.customer && closelyConfig.customer.branch;
    if (!branch || typeof branch !== 'object') {
        return { ...CLOSELY_DEFAULT };
    }
    // 脏值（对象 / 数字 / 空串）一律视为缺失，回落默认值
    const pick = (val, fallback) =>
        typeof val === 'string' && val.trim() ? val.trim() : fallback;
    return {
        appName: pick(branch.appName, CLOSELY_DEFAULT.appName),
        appIcon: pick(branch.appIcon, CLOSELY_DEFAULT.appIcon),
        downloadBadge: pick(branch.downloadBadge, CLOSELY_DEFAULT.downloadBadge)
    };
}

export { CLOSELY_DEFAULT };
